'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var appTypes = require('../../types/appTypes.js');
var PopupHelper = require('../../interactive/PopupHelper');
var util = require('../../helper/util');

/*
 @Author : mengxiaojiang
 @CreateDate : 2016-4-1
 @Descript : 弹出面板组件
 */
var PopupPanel = React.createClass({
  render: function () {
    var bgComp = this.props.items[0];
    var contentComp = this.props.items[1];
    var bg = util.Color.setOpacity(bgComp.color, 0.4);
    var dom = <div
      key={this.props.controlID}
      id={this.props.controlID}
      className='component component-PopupPanel popup-control'
      style={{
        //visibility : this.props.popup?'visible': 'hidden',
        visibility : 'visible',
        zIndex : this.props.zOrder,
      }}>
      <div id={this.props.controlID + '-background'}
           className="background"
           style={{
             width : this.props.measureWidth || 0,
             height : this.props.measureHeight || 0,
             backgroundColor : this.props.isShowBackground?bg:0,
           }}
           ref="background"
      ></div>
      <div id={this.props.controlID + '-content'}
           className="content"
           ref="content"
           style={{
             left : contentComp.x,
             top : contentComp.y,
             width : contentComp.w  + 1,
             height : contentComp.h + 1,
             boxSizing : 'border-box',
             overflow: 'visible'
           }}>
        {
          this.props.children
        }
      </div>
    </div>;

    return (dom);
  },

  doAdjustChildBounds: function () {
    //var content = ReactDOM.findDOMNode(this.refs.content);
    //var i = 0;
    //var comp = this.props.items[1];
    //for (i; i < content.children.length; i++) {
    //  $(content.children[i]).css({left:comp.items[i].x + 1});
    //}
  },

  componentDidMount: function () {
    //this.doAdjustChildBounds();
    this.doPopup();
    if(this.props.onOpened) {
      this.props.onOpened(this.props);
    }
  },

  componentDidUpdate: function () {
    this.doPopup();
  },

  doPopup: function () {
    PopupHelper.registerPopup(this);
    if (this.open) {
      this.open();
    }
    var dom = $(ReactDOM.findDOMNode(this));
    var content = $(ReactDOM.findDOMNode(this.refs.content));
    var background = $(ReactDOM.findDOMNode(this.refs.background));
    if (this.props.isPopupClosing && this.props.closePopup) {
      this.props.closePopup(dom, this.props, content, background);
    }
  }
});

module.exports = PopupPanel;



// WEBPACK FOOTER //
// ./src/views/Components/PopupPanel.jsx